export function SendIcon() {
    return (
        <svg width="38" height="40" viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9711 20.9163L8.08069 27.6367C7.73201 28.4474 8.57577 29.2591 9.41631 28.9215L29.3718 20.9081C30.2094 20.5718 30.2094 19.4282 29.3718 19.0918L9.41631 11.0785C8.57577 10.7409 7.73201 11.5526 8.08069 12.3633L10.9713 19.0843L21.426 20.0003L10.9711 20.9163Z" fill="#0f172a"/>
        </svg>

    )
}
